/**
 * Autores mock para guias estáticos (sem overlay CMS).
 * Substituível por campos do CMS/API no futuro.
 */
export type StaticGuideAuthorMock = {
  categoryId: string;
  staticId: number;
  /** ID do utilizador em `MOCK_PAINEL_USERS` / `getPainelUsers()`. */
  authorUserId: string;
  publishedAt: string;
  updatedAt?: string;
};

export const STATIC_GUIDE_AUTHOR_MOCKS: StaticGuideAuthorMock[] = [
  {
    categoryId: 'troubleshooting',
    staticId: 4,
    authorUserId: 'u-cupim',
    publishedAt: '2026-07-04T12:41:00.000Z',
    updatedAt: '2026-07-07T14:15:00.000Z',
  },
  {
    categoryId: 'troubleshooting',
    staticId: 5,
    authorUserId: 'u-guinho',
    publishedAt: '2026-06-28T10:00:00.000Z',
    updatedAt: '2026-07-05T09:30:00.000Z',
  },
  {
    categoryId: 'primeiros-passos',
    staticId: 1,
    authorUserId: 'u-paulo',
    publishedAt: '2026-06-15T16:00:00.000Z',
  },
  {
    categoryId: 'powers',
    staticId: 1,
    authorUserId: 'u-guinho',
    publishedAt: '2026-05-20T11:00:00.000Z',
    updatedAt: '2026-07-01T18:00:00.000Z',
  },
  {
    categoryId: 'troubleshooting',
    staticId: 1,
    authorUserId: 'u-cupim',
    publishedAt: '2026-04-10T09:00:00.000Z',
    updatedAt: '2026-06-22T11:45:00.000Z',
  },
];

export function findStaticGuideAuthorMock(
  categoryId: string,
  staticId: number
): StaticGuideAuthorMock | undefined {
  return STATIC_GUIDE_AUTHOR_MOCKS.find(
    (m) => m.categoryId === categoryId && m.staticId === staticId
  );
}
